export default __webpack_public_path__ + "static/media/2491.1ad38f1b.png";